import React from 'react';
import ReactDOM from 'react-dom';
import App from './src/App.js';

const app = document.querySelector('#profile-active-ads-podlet');
// const props = app.dataset;
const dataElement = document.getElementById('profile-active-ads-podlet-data');
const initalState = JSON.parse(dataElement.textContent);

ReactDOM.hydrate(<App {...initalState} />, app);
